import clsx from "clsx";
import {useState, useEffect} from "react";
import {useDispatch} from "react-redux";
import {useHistory} from "react-router-dom/cjs/react-router-dom.min";
import {API} from "src/api";
import {addToast} from "src/redux/actions/toasts";

function Config({accounts, config, updateConfig}) {
  const [formSubmitting, setFormSubmitting] = useState(false);
  const dispatch = useDispatch();
  const [error, setError] = useState("");
  const emptyFormData = {
    stripeFeesAccountCode: config?.stripeFeesAccountCode || "",
    paymentDepositAccountCode: config?.paymentDepositAccountCode || ""
  };
  const [formData, setFormData] = useState(emptyFormData);
  const [formErrors, setFormErrors] = useState({});
  const history = useHistory();


  // Update form data when config prop changes
  useEffect(() => {
    if (config) {
      console.log('Config updated:', config);
      setFormData({
        stripeFeesAccountCode: config.stripeFeesAccountCode || "",
        paymentDepositAccountCode: config.paymentDepositAccountCode || ""
      });
    }
  }, [config]);

  function handleFormChange(e) {
    const target = e.target;
    const value = target.type === "checkbox" ? target.checked : target.value;
    const name = target.name;
    setFormData({...formData, [name]: value});
    
    // Clear validation errors when user changes the field
    if (formErrors[name]) {
      setFormErrors(prevErrors => {
        const newErrors = {...prevErrors};
        delete newErrors[name];
        return newErrors;
      });
    }
  }

  async function handleFormSubmit(e) {
    e.preventDefault();
    let error = false;
    if (!formData.stripeFeesAccountCode || formData.stripeFeesAccountCode === "") {
      setFormErrors(function (formErrors) {
        return {...formErrors, stripeFeesAccountCode: "Account should be selected"};
      });
      error = true;
    }
    if (error) {
      return;
    }

    setFormSubmitting(true);
    try {
      await API.post(process.env.REACT_APP_SERVER_URL + "/deskera/accounts", formData);
      dispatch(addToast({type: "alert-success", text: "Account config was saved"}));
      updateConfig();
      history.push("/pages/invoices");
    } catch {
      setError("Failed to submit");
    }
    setFormSubmitting(false);
  }

  return (
    <div className='mt-5' style={{width: 480, margin: "auto"}}>
      <div
        className='card'
        style={{color: "#192038", border: "none", boxShadow: "0 0.5rem 1rem 0 rgba(44, 51, 73, 0.1)"}}>
        <div className='card-header px-5' style={{backgroundColor: "transparent"}}>
          <h5 className='m-0'>Account Configuration</h5>
        </div>
        <div className='card-body px-5'>
          {!accounts || accounts.length === 0 ? (
            <p>Loading accounts...</p>
          ) : (
            <>
              <p>Select COA which will be used to map Stripe fee for a transaction</p>
              <form>
                <div className='form-group'>
                  <select
                    onChange={handleFormChange}
                    name='stripeFeesAccountCode'
                    value={formData.stripeFeesAccountCode}
                    className={clsx("custom-select", formErrors.stripeFeesAccountCode && "is-invalid")}>
                    <option value=''>
                      Select account
                    </option>
                    {accounts && accounts.map(function (account, index) {
                      return (
                        <option
                          key={index}
                          value={account.code}>
                          {account.name}
                        </option>
                      );
                    })}
                  </select>
                  {formErrors.stripeFeesAccountCode && (
                    <small id='stripeFeesAccountCode-error' class='form-text text-danger'>
                      {formErrors.stripeFeesAccountCode}
                    </small>
                  )}
                </div>
                
                <p>Select COA to which payment should be synced</p>
                <div className='form-group'>
                  <select
                    onChange={handleFormChange}
                    name='paymentDepositAccountCode'
                    value={formData.paymentDepositAccountCode}
                    className={clsx("custom-select", formErrors.paymentDepositAccountCode && "is-invalid")}>
                    <option value=''>
                      Select account
                    </option>
                    {accounts && accounts.map(function (account, index) {
                      return (
                        <option
                          key={index}
                          value={account.code}>
                          {account.name}
                        </option>
                      );
                    })}
                  </select>
                  {formErrors.paymentDepositAccountCode && (
                    <small id='paymentDepositAccountCode-error' class='form-text text-danger'>
                      {formErrors.paymentDepositAccountCode}
                    </small>
                  )}
                </div>
              </form>
              <div className='pt-3' style={{display: "flex", flexDirection: "row-reverse"}}>
                <button className='btn btn-primary' onMouseDown={handleFormSubmit} disabled={formSubmitting}>
                  {formSubmitting ? (
                    <div class='spinner-border spinner-border-sm mx-3' role='status'>
                      <span class='sr-only'>Sending...</span>
                    </div>
                  ) : (config?.stripeFeesAccountCode || config?.paymentDepositAccountCode) ? (
                    "Update"
                  ) : (
                    "Save"
                  )}
                </button>
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
}

export default Config;
